import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { cls } from "app/utils";
import { useActions } from "app/utils/hooks";
import { WorkflowModel } from "app/models";
import { updateWorkflow, deleteWorkflow } from "app/actions/workflow";
import DropdownButton from "app/components/DropdownButton";
import WorkflowEditModal from "../WorkflowEditModal";
import styles from "./styles.module.scss";

interface IProps {
  workflow: WorkflowModel;
}

const WorkflowItem = ({ workflow }: IProps) => {
  const { t } = useTranslation();
  const history = useHistory();
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const canManage =
    !workflow.permissions || workflow.permissions.includes("manage");

  const workflowActions = useActions({
    updateWorkflow,
    deleteWorkflow,
  });

  const handleClick = () => {
    history.push(`/automation/facility-workflows/workflow/${workflow.id}`);
  };

  const handleCopyLink = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (workflow.qrUrl) {
      navigator.clipboard.writeText(workflow.qrUrl);
    } else if (workflow.urlToken) {
      navigator.clipboard.writeText(
        `https://app.coachnow.io/i/${workflow.urlToken}`,
      );
    }
  };

  const handleSave = (params: Partial<WorkflowModel>) => {
    return workflowActions.updateWorkflow(workflow.id, params);
  };

  const handleDelete = () => {
    workflowActions.deleteWorkflow(workflow.id);
  };

  return (
    <div className={styles.container} onClick={handleClick}>
      <div className={styles.workflow_wrapper}>
        <i className={cls("ico ico-workflow", styles.workflow_icon)} />
        <div className={styles.workflow_info}>
          <h4>{workflow.name}</h4>
          {workflow.enabled !== undefined && (
            <span
              className={cls(
                styles.status_badge,
                workflow.enabled ? styles.enabled : styles.disabled,
              )}
            >
              {workflow.enabled ? t("Active") : t("Inactive")}
            </span>
          )}
        </div>
      </div>

      {/* Wrap in stopPropagation div so clicking the dropdown doesn't trigger card navigation */}
      <div onClick={(e) => e.stopPropagation()}>
        <DropdownButton
          btnClassName={styles.dropdown_btn_className}
          btnContent={<i className="bullets" />}
        >
          <div className={styles.dropdown_container}>
            <div className={styles.dropdown_btn} onClick={handleClick}>
              {t("View")}
            </div>
            {canManage && (
              <div
                className={styles.dropdown_btn}
                onClick={() => setIsEditModalOpen(true)}
              >
                {t("Edit")}
              </div>
            )}
            <div className={styles.dropdown_btn} onClick={handleCopyLink}>
              {t("Copy Link")}
            </div>
          </div>
        </DropdownButton>
      </div>

      {/* stopPropagation here catches portal events that bubble through the React tree */}
      <div onClick={(e) => e.stopPropagation()}>
        {isEditModalOpen && (
          <WorkflowEditModal
            isOpen={isEditModalOpen}
            onClose={() => setIsEditModalOpen(false)}
            workflow={workflow}
            onSave={handleSave}
            onDelete={handleDelete}
          />
        )}
      </div>
    </div>
  );
};

export default WorkflowItem;
